const CS_DECLARATION_REGEX = /\b(?:public|private|internal|protected)?\s*(?:abstract\s+|sealed\s+|static\s+)?(class|interface)\s+[A-Za-z_]\w*/;

/**
 * Heuristic language detection for the Import tab's textarea content.
 * @param {string} source
 * @returns {string} strategy key from ImportStrategyRegistry, defaults to 'csharp'
 */
export function detectImportLanguage(source) {
  if (/@startuml/i.test(source)) {
    return 'plantuml';
  }
  if (CS_DECLARATION_REGEX.test(source)) {
    return 'csharp';
  }
  return 'csharp';
}
